export enum ComparisonType {
  Equals,
  NotEquals,
  Contains,
  StartsWith,
  EndsWith,
  GreaterThanEquals,
  LessThanEquals,
  Between,
  NotContains
}
